module.exports = __webpack_public_path__ + "img/R2N.3922e6f5.png";